'use client';

import { useEffect, useRef } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';

import { TrackProperties } from '@/app/(main)/_components/logger/analytics/plugins/analytics-plugin.types';
import { getAnalyticsPlugin } from '@/app/(main)/_components/logger/analytics/get-analytics-plugin';
import { AnalyticsEnumKeyType } from '@/types/enums/analytics/analytics.enum';

export interface TrackUserViewProps {
  eventName: AnalyticsEnumKeyType;
  properties?: TrackProperties;
}

export const useTrackUserView = ({ eventName, properties }: TrackUserViewProps): void => {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const hasTracked = useRef(false);

  useEffect(() => {
    if (!eventName || hasTracked.current) {
      return;
    }

    hasTracked.current = true;
    const analytics = getAnalyticsPlugin();
    if (analytics) {
      analytics.track(String(eventName), { ...properties, pathname, searchParams: searchParams?.toString() });
    }
  });
};
